import { logger } from '../logger';
var ANONYMOUS_IP = '0.0.0.0';
var anonymizeContextIP = function (ctx) {
    var evtCtx = ctx.event.context;
    evtCtx.ip = ANONYMOUS_IP;
    return ctx;
};
export var ddAnonymizeIPsPlugin = function () {
    return {
        name: 'Anonymize IPs',
        type: 'enrichment',
        version: '0.0.1',
        isLoaded: function () { return true; },
        load: function () {
            logger.debug('Enabling AnonymizeIPs plugin');
            return Promise.resolve();
        },
        track: anonymizeContextIP,
        identify: anonymizeContextIP,
        page: anonymizeContextIP,
        group: anonymizeContextIP,
        alias: anonymizeContextIP,
        screen: anonymizeContextIP,
    };
};
//# sourceMappingURL=index.js.map